<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner" style="position: relative;">
        <img :src="imageurl" style="width: 100%" />
        <div class="btn" style="left: 22%;top: 45%;" @click="handleTabs(4)">
          <img src="../../assets/meb/imgs/work/zzBUT@2x.png" style="width: 100%" />
        </div>
        <div class="btn" style="left: 38%;top: 20%;" @click="handleTabs(1)">
          <img src="../../assets/meb/imgs/work/cyBUT@2x.png" style="width: 100%" />
        </div>
        <div class="btn" style="left: 35%;top: 33%;" @click="handleTabs(5)">
          <img src="../../assets/meb/imgs/work/dcBUT@2x.png" style="width: 100%" />
        </div>
        <div class="btn" style="left: 50%;top: 25%;" @click="handleTabs(2)">
          <img src="../../assets/meb/imgs/work/csBUT@2x.png" style="width: 100%" />
        </div>
        <div class="btn" style="left: 75%;top: 45%;" @click="handleTabs(3)">
          <img src="../../assets/meb/imgs/work/yqBUT@2x.png" style="width: 100%" />
        </div>
        <div class="btn btnClick" style="left: 40%;top: 23%;">
          <img src="../../assets/meb/imgs/work/click.gif" style="width: 100%" />
        </div>
        <div style="margin-top: -58px;">
          <contentMenu :index="3"></contentMenu>
        </div>
      </div>
      <div class="main2-content">
        <div class="img">
          <img src="../../assets/meb/imgs/work/cjgyTop@2x.png" style="width: 100%" />
        </div>
        <contentRight :list="list[0]" isBtnShow></contentRight>
        <contentLeft :list="list[1]" isBtnShow></contentLeft>
        <contentRight :list="list[2]" isBtnShow></contentRight>
        <contentLeft :list="list[3]" isBtnShow></contentLeft>
        <contentRight :list="list[4]" isBtnShow></contentRight>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenu.vue";
import contentLeft from "./contentLeft.vue";
import contentRight from "./contentRight.vue";
import contentRight2 from "./contentRight2.vue";
export default {
  components: {
    contentMenu,
    contentLeft,
    contentRight,
    contentRight2
  },
  data() {
    return config.work;
  },
  mounted() {},
  methods: {
    handleTabs(index) {
      let route = this.$router.resolve({
        name: "workshop",
        query: { index: index }
      });
      window.open(route.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
  background-image: url("../../assets/meb/imgs/CYbg@2x.png");
  background-size: 100% 100%;
  background-repeat-x: no-repeat;
}
.divHeight {
  height: 23px;
}
.btn {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 151px;
  height: 50px;
  cursor: pointer;
}
.btnClick {
  width: 22px;
  height: 37px;
  z-index: 1;
}
.img {
  width: 1200px;
  padding: 49px 60px 49px 68px;
  box-sizing: border-box;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (min-width: 1600px) {
  .btn {
    width: 201px;
    height: 66px;
  }
  .btnClick {
    width: 29px;
    height: 49px;
  }
  .img {
    width: 1600px;
  }
}
</style>
